import script from "./CadastroNoticia.vue?vue&type=script&setup=true&lang=js"
export * from "./CadastroNoticia.vue?vue&type=script&setup=true&lang=js"

import "./CadastroNoticia.vue?vue&type=style&index=0&id=4e03cdfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e03cdfa"]])

export default __exports__